export const dateParse = (date) => {
    let parseDate = new Date(date);
    const month = parseDate.toLocaleString('default', { month: 'short' });
    const day = parseDate.getDate();
    const year = parseDate.getFullYear();
    return (month + ". " + day + ", " + year);
};

export const cleanLink = (link) => {
    let cleanedLink = link;
    // strip the spaces from the url if any are present
    cleanedLink = "http" + cleanedLink.replace(/\s+/g, '');

    const lastCharNum = cleanedLink.length - 1;

    // if link's last character is a ";" or ",", remove those characters
    if(cleanedLink.charAt(lastCharNum) === ";" || cleanedLink.charAt(lastCharNum) === ",") {
        cleanedLink = cleanedLink.slice(0, -1);
    } 

    return cleanedLink;
}